/*jslint white: true, nomen: true, unparam : true, es5: true */
/*global document, window, Cookies, jQuery, Swiper */
(function( $ ) {
    "use strict";

    function loadYouTubeAPI() {
        if ( window.YT && window.YT.Player ) { return Promise.resolve(); }
        if ( window.__phiYTPromise ) { return window.__phiYTPromise; }
        window.__phiYTPromise = new Promise( function( resolve ) {
            var prev = window.onYouTubeIframeAPIReady;
            window.onYouTubeIframeAPIReady = function() {
                if ( typeof prev === "function" ) { prev(); }
                resolve();
            };
            var tag = document.createElement( "script" );
            tag.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild( tag );
        } );
        return window.__phiYTPromise;
    }

    function loadVimeoAPI() {
        if ( window.Vimeo && window.Vimeo.Player ) { return Promise.resolve(); }
        if ( window.__phiVimeoPromise ) { return window.__phiVimeoPromise; }
        window.__phiVimeoPromise = new Promise( function( resolve ) {
            var tag = document.createElement( "script" );
            tag.src = "https://player.vimeo.com/api/player.js";
            tag.onload = function() { resolve(); };
            document.head.appendChild( tag );
        } );
        return window.__phiVimeoPromise;
    }

    function setPlayPressed( handle, playing ) {
        var btn = handle.wrap.querySelector( "[data-phi-play]" );
        if ( ! btn ) { return; }
        btn.setAttribute( "aria-pressed", playing ? "true" : "false" );
        btn.setAttribute( "aria-label", playing ? "Mettre en pause" : "Lire la vidéo" );
    }

    function bindPlayToggle( handle ) {
        var btn = handle.wrap.querySelector( "[data-phi-play]" );
        if ( ! btn ) { return; }
        btn.addEventListener( "click", function( ev ) {
            ev.stopPropagation();
            var playing = "true" === btn.getAttribute( "aria-pressed" );
            try {
                if ( playing ) { handle.pause(); } else { handle.play(); }
            } catch ( e ) {}
        } );
    }

    function bindSoundToggle( handle ) {
        var btn = handle.wrap.querySelector( "[data-phi-sound]" );
        if ( ! btn ) { return; }
        btn.addEventListener( "click", function( ev ) {
            ev.stopPropagation();
            var pressed = "true" === btn.getAttribute( "aria-pressed" );
            var next    = ! pressed;
            try { handle.setMuted( ! next ); } catch ( e ) { return; }
            btn.setAttribute( "aria-pressed", next ? "true" : "false" );
            btn.setAttribute( "aria-label", next ? "Couper le son" : "Activer le son" );
        } );
    }

    function bindFullscreenToggle( handle ) {
        var btn = handle.wrap.querySelector( "[data-phi-fullscreen]" );
        if ( ! btn ) { return; }
        var wrap            = handle.wrap;
        var nativeSupported = !! ( wrap.requestFullscreen || wrap.webkitRequestFullscreen );
        var fallbackClass   = "phi-slide__video--fs-fallback";
        var bodyLockClass   = "phi-slide--fs-lock";
        var fallbackHome    = null;

        function nativeFsElement() {
            return document.fullscreenElement || document.webkitFullscreenElement || null;
        }
        function nativeRequest() {
            if ( wrap.requestFullscreen )       { return wrap.requestFullscreen(); }
            if ( wrap.webkitRequestFullscreen ) { return wrap.webkitRequestFullscreen(); }
        }
        function nativeExit() {
            if ( document.exitFullscreen )       { return document.exitFullscreen(); }
            if ( document.webkitExitFullscreen ) { return document.webkitExitFullscreen(); }
        }

        function fallbackActive() {
            return wrap.classList.contains( fallbackClass );
        }
        function onEscKey( ev ) {
            if ( "Escape" === ev.key || 27 === ev.keyCode ) { fallbackExit(); }
        }
        function fallbackEnter() {
            if ( ! fallbackHome ) {
                fallbackHome = { parent: wrap.parentNode, next: wrap.nextSibling };
                document.body.appendChild( wrap );
            }
            wrap.classList.add( fallbackClass );
            document.body.classList.add( bodyLockClass );
            document.addEventListener( "keydown", onEscKey );
            syncBtn();
        }
        function fallbackExit() {
            wrap.classList.remove( fallbackClass );
            document.body.classList.remove( bodyLockClass );
            document.removeEventListener( "keydown", onEscKey );
            if ( fallbackHome ) {
                fallbackHome.parent.insertBefore( wrap, fallbackHome.next );
                fallbackHome = null;
            }
            syncBtn();
        }

        function isActive() {
            if ( handle.isFs ) {
                try { if ( handle.isFs() ) { return true; } } catch ( e ) {}
            }
            if ( nativeSupported && nativeFsElement() === wrap ) { return true; }
            return fallbackActive();
        }
        function tryNativeOrFallback() {
            if ( nativeSupported ) {
                try {
                    var p = nativeRequest();
                    if ( p && typeof p.catch === "function" ) {
                        p.catch( function() { fallbackEnter(); } );
                    }
                    return;
                } catch ( e ) {}
            }
            fallbackEnter();
        }
        function enter() {
            if ( handle.enterFs ) {
                try {
                    var r = handle.enterFs();
                    if ( r && typeof r.catch === "function" ) {
                        r.catch( function() { tryNativeOrFallback(); } );
                    }
                    return;
                } catch ( e ) {}
            }
            tryNativeOrFallback();
        }
        function exit() {
            if ( handle.exitFs ) {
                try {
                    var r = handle.exitFs();
                    if ( r && typeof r.catch === "function" ) { r.catch( function() {} ); }
                } catch ( e ) {}
            }
            if ( nativeSupported && nativeFsElement() === wrap ) {
                try { nativeExit(); } catch ( e ) {}
            }
            if ( fallbackActive() ) { fallbackExit(); }
        }
        function syncBtn() {
            var active = isActive();
            btn.setAttribute( "aria-pressed", active ? "true" : "false" );
            btn.setAttribute( "aria-label", active ? "Quitter le plein écran" : "Passer en plein écran" );
        }

        handle.__phiSyncFsBtn = syncBtn;

        btn.addEventListener( "click", function( ev ) {
            ev.stopPropagation();
            if ( isActive() ) { exit(); } else { enter(); }
        } );
        document.addEventListener( "fullscreenchange", syncBtn );
        document.addEventListener( "webkitfullscreenchange", syncBtn );
    }

    function bindVideos( el, opts ) {
        var ytWraps = el.querySelectorAll( ".phi-slide__video[data-provider='youtube']" );
        var vmWraps = el.querySelectorAll( ".phi-slide__video[data-provider='vimeo']" );
        if ( ! ytWraps.length && ! vmWraps.length ) { return; }
        var swiper = el.__phiSwiper;
        var players = [];

        function onPlay( handle ) {
            if ( swiper && swiper.autoplay ) { swiper.autoplay.stop(); }
            setPlayPressed( handle, true );
        }
        function onPauseEnd( handle ) {
            if ( opts.autoplay && swiper && swiper.autoplay ) { swiper.autoplay.start(); }
            setPlayPressed( handle, false );
        }

        if ( ytWraps.length ) {
            loadYouTubeAPI().then( function() {
                ytWraps.forEach( function( wrap ) {
                    var iframe = wrap.querySelector( "iframe" );
                    if ( ! iframe ) { return; }
                    var handle = { wrap: wrap, provider: "youtube" };
                    var p = new window.YT.Player( iframe, {
                        events: {
                            onReady: function() {
                                handle.play     = function() { p.playVideo(); };
                                handle.pause    = function() { p.pauseVideo(); };
                                handle.setMuted = function( m ) { if ( m ) { p.mute(); } else { p.unMute(); } };
                                bindPlayToggle( handle );
                                bindSoundToggle( handle );
                                bindFullscreenToggle( handle );
                            },
                            onStateChange: function( e ) {
                                var YT = window.YT;
                                if ( e.data === YT.PlayerState.PLAYING ) {
                                    onPlay( handle );
                                } else if ( e.data === YT.PlayerState.PAUSED || e.data === YT.PlayerState.ENDED ) {
                                    onPauseEnd( handle );
                                }
                            }
                        }
                    } );
                    players.push( handle );
                } );
            } );
        }

        if ( vmWraps.length ) {
            loadVimeoAPI().then( function() {
                vmWraps.forEach( function( wrap ) {
                    var iframe = wrap.querySelector( "iframe" );
                    if ( ! iframe ) { return; }
                    var p     = new window.Vimeo.Player( iframe );
                    var vmFs  = false;
                    var handle = {
                        wrap: wrap,
                        provider: "vimeo",
                        play:     function() { p.play().catch( function() {} ); },
                        pause:    function() { p.pause(); },
                        setMuted: function( m ) { p.setMuted( m ); },
                        enterFs:  function() { return p.requestFullscreen(); },
                        exitFs:   function() { return p.exitFullscreen(); },
                        isFs:     function() { return vmFs; }
                    };
                    p.on( "play",  function() { onPlay( handle ); } );
                    p.on( "pause", function() { onPauseEnd( handle ); } );
                    p.on( "ended", function() { onPauseEnd( handle ); } );
                    p.on( "fullscreenchange", function( data ) {
                        vmFs = !! ( data && data.fullscreen );
                        if ( handle.__phiSyncFsBtn ) { handle.__phiSyncFsBtn(); }
                    } );
                    bindPlayToggle( handle );
                    bindSoundToggle( handle );
                    bindFullscreenToggle( handle );
                    players.push( handle );
                } );
            } );
        }

        if ( swiper ) {
            swiper.on( "slideChange", function() {
                players.forEach( function( h ) {
                    try { if ( h.pause ) { h.pause(); } } catch ( e ) {}
                } );
            } );
        }
    }

    function initPhilocaleCarousels() {
        if ( typeof window.Swiper === "undefined" ) { return; }
        document.querySelectorAll( ".philocale-carousel" ).forEach( function( el ) {
            if ( el.__phiSwiper ) { return; }
            var opts = {};
            try { opts = JSON.parse( el.getAttribute( "data-phi-carousel" ) || "{}" ); } catch ( e ) {}
            var cfg = {
                loop: !!opts.loop,
                slidesPerView: 1,
                spaceBetween: 0
            };
            if ( opts.pagination ) {
                cfg.pagination = { el: el.querySelector( ".swiper-pagination" ), clickable: true };
            }
            if ( opts.navigation ) {
                cfg.navigation = {
                    nextEl: el.querySelector( ".swiper-button-next" ),
                    prevEl: el.querySelector( ".swiper-button-prev" )
                };
            }
            if ( opts.autoplay ) {
                cfg.autoplay = { delay: opts.autoplayDelay || 5000, disableOnInteraction: false };
            }
            el.__phiSwiper = new window.Swiper( el, cfg );
            bindVideos( el, opts );
        } );
    }

    function initPhilocaleGalleries() {
        if ( typeof window.Swiper === "undefined" ) { return; }
        document.querySelectorAll( ".philocale-gallery" ).forEach( function( el ) {
            if ( el.__phiSwiper ) { return; }
            var opts = {};
            try { opts = JSON.parse( el.getAttribute( "data-phi-gallery" ) || "{}" ); } catch ( e ) {}
            var desktopSpace = opts.spaceBetween || 40;
            var cfg = {
                loop: !!opts.loop,
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 10,
                observer: true,
                observeParents: true,
                breakpoints: {
                    768:  { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: desktopSpace },
                    1024: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: desktopSpace },
                    1366: { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: desktopSpace }
                }
            };
            if ( opts.pagination ) {
                cfg.pagination = { el: el.querySelector( ".swiper-pagination" ), clickable: true };
            }
            if ( opts.navigation ) {
                cfg.navigation = {
                    nextEl: el.querySelector( ".swiper-button-next" ),
                    prevEl: el.querySelector( ".swiper-button-prev" )
                };
            }
            var swiper = new window.Swiper( el, cfg );
            el.__phiSwiper = swiper;
            el.querySelectorAll( ".phi-item__media img" ).forEach( function( img ) {
                if ( ! img.complete ) {
                    img.addEventListener( "load", function() { swiper.update(); } );
                }
            } );
        } );
    }

    function syncPhilocaleFocusSlideWidths( el, swiper ) {
        el.querySelectorAll( ".phi-focus-slide" ).forEach( function( slide ) {
            var img = slide.querySelector( ".phi-focus-slide__media img" );
            if ( ! img || ! img.naturalWidth || ! img.naturalHeight ) { return; }
            var cssHeight = parseFloat( window.getComputedStyle( img ).height ) || img.offsetHeight;
            if ( ! cssHeight ) { return; }
            var displayedWidth = ( img.naturalWidth / img.naturalHeight ) * cssHeight;
            var maxAllowed = window.innerWidth * 0.9;
            slide.style.width = Math.min( displayedWidth, maxAllowed ) + "px";
        } );
        if ( swiper && typeof swiper.update === "function" ) { swiper.update(); }
    }

    function initPhilocaleFocus() {
        if ( typeof window.Swiper === "undefined" ) { return; }
        document.querySelectorAll( ".philocale-focus" ).forEach( function( el ) {
            if ( el.__phiSwiper ) { return; }
            var opts = {};
            try { opts = JSON.parse( el.getAttribute( "data-phi-focus" ) || "{}" ); } catch ( e ) {}
            var cfg = {
                loop: !!opts.loop,
                centeredSlides: false,
                slidesPerView: "auto",
                spaceBetween: 20,
                observer: true,
                observeParents: true,
                breakpoints: {
                    1024: {
                        centeredSlides: true,
                        spaceBetween: 70
                    }
                }
            };
            if ( opts.navigation ) {
                cfg.navigation = {
                    nextEl: el.querySelector( ".swiper-button-next" ),
                    prevEl: el.querySelector( ".swiper-button-prev" )
                };
            }
            var swiper = new window.Swiper( el, cfg );
            el.__phiSwiper = swiper;
            syncPhilocaleFocusSlideWidths( el, swiper );
            el.querySelectorAll( ".phi-focus-slide__media img" ).forEach( function( img ) {
                if ( ! img.complete ) {
                    img.addEventListener( "load", function() { syncPhilocaleFocusSlideWidths( el, swiper ); } );
                }
            } );
            window.addEventListener( "resize", function() { syncPhilocaleFocusSlideWidths( el, swiper ); } );
        } );
    }

    function initPhilocaleSale() {
        if ( typeof window.Swiper === "undefined" ) { return; }
        document.querySelectorAll( ".philocale-sale" ).forEach( function( el ) {
            if ( el.__phiSwiper ) { return; }
            var opts = {};
            try { opts = JSON.parse( el.getAttribute( "data-phi-sale" ) || "{}" ); } catch ( e ) {}
            var cfg = {
                loop: !!opts.loop,
                centeredSlides: false,
                slidesPerView: "auto",
                spaceBetween: 20,
                observer: true,
                observeParents: true,
                breakpoints: {
                    1024: {
                        centeredSlides: true,
                        spaceBetween: 40
                    }
                }
            };
            if ( opts.navigation ) {
                cfg.navigation = {
                    nextEl: el.querySelector( ".swiper-button-next" ),
                    prevEl: el.querySelector( ".swiper-button-prev" )
                };
            }
            el.__phiSwiper = new window.Swiper( el, cfg );
        } );
    }

    function initPhilocaleInsta() {
        if ( typeof window.Swiper === "undefined" ) { return; }
        document.querySelectorAll( ".philocale-insta" ).forEach( function( el ) {
            if ( el.__phiSwiper ) { return; }
            var cfg = {
                slidesPerView: "auto",
                spaceBetween: 20,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: el.querySelector( ".swiper-button-next" ),
                    prevEl: el.querySelector( ".swiper-button-prev" )
                },
                breakpoints: {
                    1024: {
                        spaceBetween: 70
                    }
                }
            };
            var swiper = new window.Swiper( el, cfg );
            el.__phiSwiper = swiper;
            // Une image en erreur afficherait son alt sur une ligne, en
            // guise de slide démesurée : on retire la slide.
            var drop = function( img ) {
                img.closest( ".phi-insta-slide" ).remove();
                if ( ! el.querySelector( ".phi-insta-slide" ) ) {
                    el.hidden = true;
                }
                swiper.update();
            };
            el.querySelectorAll( ".phi-insta-slide img" ).forEach( function( img ) {
                if ( img.complete ) {
                    if ( 0 === img.naturalWidth ) { drop( img ); }
                    return;
                }
                img.addEventListener( "load", function() { swiper.update(); } );
                img.addEventListener( "error", function() { drop( img ); } );
            } );
        } );
    }

    function initStickyHeader() {
        var header = document.querySelector( ".elementor-location-header" );
        if ( ! header ) { return; }
        var toggle = function() {
            if ( window.scrollY > 0 ) {
                header.classList.add( "sticky" );
            } else {
                header.classList.remove( "sticky" );
            }
        };
        toggle();
        window.addEventListener( "scroll", toggle, { passive: true } );
    }

    // arrivée externe avec #hash : Safari iOS / Firefox mobile ignorent parfois
    // scroll-padding-top / scroll-margin-top au chargement initial.
    // Stratégie : scroll immédiat dès le DOM prêt (corrige le gros décalage
    // visible), puis ré-ajustements à chaque image décodée + une fois après
    // window.load pour le calage final. Offset calculé sur la hauteur réelle
    // du header sticky.
    function fixInitialHashScroll() {
        if ( ! window.location.hash ) { return; }
        var target;
        try {
            target = document.querySelector( window.location.hash );
        } catch ( e ) {
            return;
        }
        if ( ! target ) { return; }

        var doScroll = function() {
            var header = document.querySelector( ".elementor-location-header" );
            var offset = header ? header.getBoundingClientRect().height : 0;
            var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo( 0, top );
        };

        // 1) scroll immédiat — corrige le décalage dû au header sticky avant
        //    même que les images aient fini de charger
        doScroll();

        // 2) ré-ajuste à chaque image qui finit de charger entre la cible
        //    et le haut du document (au-dessus = celles qui décalent le layout)
        var images = document.querySelectorAll( "img" );
        var i;
        for ( i = 0; i < images.length; i++ ) {
            if ( ! images[ i ].complete ) {
                images[ i ].addEventListener( "load", doScroll, { once: true } );
                images[ i ].addEventListener( "error", doScroll, { once: true } );
            }
        }

        // 3) calage final après load complet
        window.addEventListener( "load", function() {
            requestAnimationFrame( doScroll );
        } );
    }

    // Transforme les champs upload Elementor en bouton custom "Choisir un
    // fichier" + liste des fichiers sélectionnés avec suppression unitaire.
    // L'input natif est gardé dans le DOM (visuellement masqué) pour que
    // la soumission du formulaire continue de fonctionner.
    function initPhilocaleFileUploads() {
        var fields = document.querySelectorAll( ".elementor-field-type-upload" );
        if ( ! fields.length ) { return; }

        Array.prototype.forEach.call( fields, function( field ) {
            if ( "1" === field.getAttribute( "data-phi-upload-init" ) ) { return; }
            field.setAttribute( "data-phi-upload-init", "1" );

            var input = field.querySelector( "input[type=\"file\"].elementor-upload-field" );
            if ( ! input ) { return; }

            input.classList.add( "phi-upload-input--hidden" );

            var label = document.createElement( "label" );
            label.className = "phi-upload-button";
            label.setAttribute( "for", input.id );
            label.textContent = "Choisir un fichier";

            var list = document.createElement( "ul" );
            list.className = "phi-upload-list";

            input.insertAdjacentElement( "afterend", list );
            input.insertAdjacentElement( "afterend", label );

            function renderList() {
                while ( list.firstChild ) { list.removeChild( list.firstChild ); }
                var files = input.files;
                if ( ! files || ! files.length ) { return; }

                var i;
                for ( i = 0; i < files.length; i++ ) {
                    var li = document.createElement( "li" );
                    li.className = "phi-upload-item";

                    var name = document.createElement( "span" );
                    name.className = "phi-upload-item__name";
                    name.textContent = files[ i ].name;

                    var btn = document.createElement( "button" );
                    btn.type = "button";
                    btn.className = "phi-upload-item__remove";
                    btn.setAttribute( "aria-label", "Retirer " + files[ i ].name );
                    btn.setAttribute( "data-phi-index", String( i ) );

                    li.appendChild( name );
                    li.appendChild( btn );
                    list.appendChild( li );
                }
            }

            input.addEventListener( "change", renderList );

            list.addEventListener( "click", function( ev ) {
                var btn = ev.target.closest && ev.target.closest( ".phi-upload-item__remove" );
                if ( ! btn ) { return; }

                var idx = parseInt( btn.getAttribute( "data-phi-index" ), 10 );
                if ( isNaN( idx ) ) { return; }

                if ( "undefined" === typeof DataTransfer ) { return; }

                var dt = new DataTransfer();
                var files = input.files;
                var i;
                for ( i = 0; i < files.length; i++ ) {
                    if ( i !== idx ) { dt.items.add( files[ i ] ); }
                }
                try {
                    input.files = dt.files;
                } catch ( e ) {
                    return;
                }
                renderList();
            } );
        } );
    }

    $( function() {
        initPhilocaleCarousels();
        initPhilocaleGalleries();
        initPhilocaleFocus();
        initPhilocaleSale();
        initPhilocaleInsta();
        initStickyHeader();
        fixInitialHashScroll();
        initPhilocaleFileUploads();
    } );

    if ( window.elementorFrontend ) {
        window.elementorFrontend.hooks.addAction( "frontend/element_ready/philocale-carousel.default", function() {
            initPhilocaleCarousels();
        } );
        window.elementorFrontend.hooks.addAction( "frontend/element_ready/philocale-gallery.default", function() {
            initPhilocaleGalleries();
        } );
        window.elementorFrontend.hooks.addAction( "frontend/element_ready/philocale-focus.default", function() {
            initPhilocaleFocus();
        } );
        window.elementorFrontend.hooks.addAction( "frontend/element_ready/philocale-sale.default", function() {
            initPhilocaleSale();
        } );
    }

}( jQuery ) );
